import React from 'react';

interface CountownProps {
  start: number;
  onComplete: () => void;
}

export default function Countdown({
  start,
  onComplete,
}: CountownProps) {
  const [counter, setCounter] = React.useState(start);
  const minutes = Math.floor(counter / 60);
  const seconds = counter - minutes * 60;

  React.useEffect(() => {
    if (counter > 0) {
      const timer = setInterval(() => setCounter(counter - 1), 1000);
      return () => clearInterval(timer);
    }
    if (onComplete) {
      onComplete();
    }
    return undefined;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [counter]);

  return (
    <div className="Countdown">
      {
        counter > 0 && [minutes, seconds].map(val => `0${val}`.slice(-2)).join(':')
      }
    </div>
  );
}
